import React, { Dispatch, PropsWithChildren, SetStateAction, createContext, useContext, useEffect, useState } from 'react'
import { setInterceptors } from '../axiosInstance/axiosInstance';

interface FormatContext {
    user: FormatUser | null,
    setUser: Dispatch<SetStateAction<FormatUser | null>>,
    authenticated: boolean,
    loading: boolean,
    setLoading: Dispatch<SetStateAction<boolean>>
    currentPage: number,
    setCurrentPage: Dispatch<SetStateAction<number>>
    logout: any
}

export interface FormatUser {
    has_plan: boolean;
    config: number;
    use_id: number;
    nick_name: string;
    email: string;
    recover_password: boolean;
    verification_code: string;
    expiration_date: string;
    status: string;
    created_at: string;
    updated_at: string;
    doctor: Doctor;
    person: Person;
    profile_picture_url:string | any
}

interface Person {
    per_id: number;
    use_id: number;
    name: string;
    last_name: string | null;
    cpf: string | null;
    birthday: string | null;
    created_at: string | null;
    updated_at: string | null;
    phone_numbers: PhoneNumber[];
    addresses: Address[];
}

interface Doctor {
    doc_id: number;
    use_id: number;
    gov_license: string;
    created_at: string;
    updated_at: string;
}

interface PhoneNumber {
    pho_id: number;
    per_id: number;
    ddi: string;
    ddd: string;
    number: string;
    status: string;
    verified: boolean;
    last_contact: string | null;
    created_at: string;
    updated_at: string;
}

interface Address {
    add_id: number;
    per_id: number;
    city: string;
    state: string;
    status: string;
    country: string;
    line1: string;
    line2: string | null;
    postal_code: string;
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
}
export const ContextAuth = createContext<FormatContext>({} as FormatContext)

const AuthProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const [user, setUser] = useState<FormatUser | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [currentPage, setCurrentPage] = useState<number>(1);

    useEffect(() => {
        setInterceptors(setUser)
    }, [])

    useEffect(() => {
        try {
            const data: any = localStorage.getItem("usuario")
            setUser(JSON.parse(data))
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }, [setUser])

    async function logout() {
        setUser(null)
        localStorage.clear();
    }

  

    return (
        <ContextAuth.Provider value={{ user, setUser, authenticated: !!user, loading, setLoading, currentPage, setCurrentPage, logout }}>
            {false && <pre>{JSON.stringify(user, null, 2)}</pre>}
            {children}
        </ContextAuth.Provider>
    )
}

export default AuthProvider

const useAuth = () => {
    const context = useContext(ContextAuth)
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
}
export { useAuth }